import { SignupService } from 'src/app/services/signup/signup.service';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import Utils from 'src/app/helpers/utils';
import { MaskPipe } from 'ngx-mask';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ApprovalService } from 'src/app/services/approval/approval.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalFilesUrlsProps } from '../dashboard-approval-attachments/dashboard-approval-attachments.component';
import employeesOptions from 'src/app/data/employeesOptions';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-dashboard-approval-complementary',
  templateUrl: './dashboard-approval-complementary.component.html',
  styleUrls: ['./dashboard-approval-complementary.component.scss'],
})
export class DashboardApprovalComplementaryComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  private isApplyingStyles = false;
  private stylesTimeout: any;
  private isLoadingData = false; // Flag para evitar loops na versão principal
  private isLoadingMainData = false; // Flag para evitar loops na versão main
  private isLoadingComparingData = false; // Flag para evitar loops na versão comparing
  @ViewChild('modalRoot') modalRoot;
  @Input() comparingVersions: boolean = false;
  @Input() activeTab: string = 'complementary';
  @Input() registrationExpirationInfo: any = null;
  @Input() isOnlyRepresentative: boolean = false;
  @Input() hasRepresentativeRole: boolean = false;

  approval: UserApprovalResponse = { register: {} } as any;
  mainApproval: UserApprovalResponse = { register: {} } as any;
  comparingApproval: UserApprovalResponse = { register: {} } as any;

  filteredFiles: any = {};
  mainFilteredFiles: any = {};
  comparingFilteredFiles: any = {};

  bankColumns: TableColumnList<Bankinformation>[] = [
    {
      name: 'Banco',
      cell: (row) => `<span>${row.bank.bank_code} - ${row.bank.name}</span>`,
      size: 2,
    },
    {
      name: 'Conta',
      cell: (row) =>
        `Ag: ${row.agency} Conta: ${row.account_number}${
          row.account_digit ? '-' + row.account_digit : ''
        }`,
    },
    {
      name: 'Tipo de conta',
      cell: (row) => `
      <span>${row.account_type_display ?? 'Conta corrente'}</span>
      <span class="app-table-details-body-row-subtitle">${
        row.main_account ? 'Conta principal' : ''
      }</span>`,
    },
  ];
  bankData: Bankinformation[] = [];
  mainBankData: Bankinformation[] = [];
  comparingBankData: Bankinformation[] = [];
  representativeData: Array<{
    id: string;
    name: string;
    document: string;
    needsSignature: boolean;
  }> = [];
  requested_signs: CompanySign[] = [];
  private requestedSignsLoaded = false;

  economicGroupColumns: TableColumnList<Economicgroup>[] = [
    { name: 'Razão Social', cell: (row) => row.corporate_name.toUpperCase() },
    {
      name: 'CNPJ',
      cell: (row) => this.formatCnpj(row.company_document_number),
    },
  ];

  economicGroupData: Economicgroup[] = [];
  mainEconomicGroupData: Economicgroup[] = [];
  comparingEconomicGroupData: Economicgroup[] = [];

  pepColumns: TableColumnList<CompanyComplementaryPepListValues>[] = [
    {
      name: 'Nome',
      cell: (row) => `
    <span>${row.name ?? '-'}</span>
    <span class="app-table-details-body-row-subtitle">${
      row.document ?? '-'
    }</span>
  `,
    },
    { name: 'Vínculo', cell: (row) => row.bound ?? '-' },
  ];

  pepData: CompanyComplementaryPepListValues | null = null;
  mainPepData: CompanyComplementaryPepListValues | null = null;
  comparingPepData: CompanyComplementaryPepListValues | null = null;

  riskColumns: TableColumnList<any>[] = [
    { name: 'Fator', cell: (row) => row.factor || '-' },
    { name: 'Risco', cell: (row) => row.risk || '-' },
    { name: 'Descrição', cell: (row) => row.description || '-' },
  ];

  riskData: any[] = [];
  mainRiskData: any[] = [];
  comparingRiskData: any[] = [];

  riskLoaded = false;

  documents: any[] = [];

  uspersonColumns: TableColumnList<any>[] = [
    { name: 'Arquivo', cell: (row) => this.formatFileName(row.file) },
    {
      name: 'Emissão',
      cell: (row) => this.formateDate(row.created_at),
    },
    {
      name: '',
      cell: (row) =>
        `<div class="icon-container">
            <div class="power-details row-${row.id}">
                <svg-icon src="assets/images/icon-eye.svg"
                    class="ml-auto"></svg-icon>
            </div>
        </div> `,
    },
  ];

  role = '';

  isSimplified = false;
  mainIsSimplified = false;
  comparingIsSimplified = false;

  cards: any;
  mainCards: any;
  comparingCards: any;

  isFund = false;
  mainIsFund = false;
  comparingIsFund = false;

  file: any = null;
  modalFiles: any = null;
  modalFilesUrls: ModalFilesUrlsProps[] | null = null;
  selectedFile: ModalFilesUrlsProps | null = null;

  employeesOptions = employeesOptions;

  isAdmin = false;
  fatca: FatcaProps = null;
  declarations = null;
  isPDF = false;
  url: any;
  isXLS = false;
  loading = false;

  cardLoading = {
    basic_data: true,
    address: true,
    bank_information: true,
    pep_relationship: true,
    economic_group: true,
    risk_information: true,
  };

  showed = false;
  event: any;
  event2: any;
  eventMainVersion: any;
  eventComparingVersion: any;

  mainCardLoading = {
    basic_data: true,
    address: true,
    bank_information: true,
    pep_relationship: true,
    economic_group: true,
    risk_information: true,
  };

  comparingCardLoading = {
    basic_data: true,
    address: true,
    bank_information: true,
    pep_relationship: true,
    economic_group: true,
    risk_information: true,
  };

  private addressLoaded = false;
  private bankLoaded = false;
  private economicGroupLoaded = false;

  constructor(
    private signupService: SignupService,
    private maskPipe: MaskPipe,
    private router: Router,
    private authService: AuthService,
    public approvalService: ApprovalService,
    private sanitizer: DomSanitizer,
    private api: ApiService,
    private route: ActivatedRoute,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  checkAndLoadTabData() {
    if (
      this.activeTab === 'address' &&
      !this.addressLoaded &&
      !this.cardLoading.address
    ) {
      this.loadAddressData();
    } else if (
      this.activeTab === 'bank' &&
      !this.bankLoaded &&
      !this.cardLoading.bank_information
    ) {
      this.loadBankData();
    } else if (
      this.activeTab === 'economic-group' &&
      !this.economicGroupLoaded &&
      !this.cardLoading.economic_group
    ) {
      this.loadEconomicGroupData();
    } else if (this.activeTab === 'risk') {
      if (this.comparingVersions) {
        if (!this.mainCardLoading.risk_information) {
          this.loadRiskData(null, null, 'main');
        }
        if (!this.comparingCardLoading.risk_information) {
          this.loadRiskData(null, null, 'comparing');
        }
      } else if (!this.riskLoaded && !this.cardLoading.risk_information) {
        this.loadRiskData();
      }
    }
  }

  async loadAddressData(
    register_uuid: string = null,
    versionToUse: number = null,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    if (!register_uuid) {
      register_uuid =
        this.approvalService.approvalData?.approval?.register?.id ||
        this.route.snapshot.params['id'];
    }

    // Gerenciar loading específico
    if (versionType === 'main') {
      this.mainCardLoading.address = true;
    } else if (versionType === 'comparing') {
      this.comparingCardLoading.address = true;
    } else {
      this.cardLoading.address = true;
    }

    try {
      const params: any = {
        data_type: 'address',
      };

      if (versionToUse) {
        params.version = versionToUse;
      } else if (this.approvalService.approvalData.version) {
        params.version = this.approvalService.approvalData.version;
      } else {
        params.last = true;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: params,
        token: true,
      });

      if (response && response.data) {
        // Usa o método existente para processar e atribuir os dados
        this.processAddressData(response, versionType);

        // Atualizar arquivos se necessário
        const v3Data = response.data;
        const versionData =
          v3Data.versions?.address?.versions?.[0] || v3Data.versions?.address;

        if (versionData?.files) {
          this.processFiles(versionData.files, 'address');
        }

        // Recuperar addressData para cache
        const addressData = versionData?.data || v3Data.data;

        this.addressLoaded = true;

        // Atualizar cache se não estiver comparando versões
        if (!versionType && !this.comparingVersions) {
          const currentData =
            this.approvalService.approvalData.complementary_data || {};
          this.approvalService.approvalData.complementary_data = {
            ...currentData,
            register: {
              ...(currentData.register || {}),
              address: addressData,
            },
          };
        }
      }
    } catch (error) {
      console.error('Error loading address data:', error);
    } finally {
      if (versionType === 'main') {
        this.mainCardLoading.address = false;
      } else if (versionType === 'comparing') {
        this.comparingCardLoading.address = false;
      } else {
        this.cardLoading.address = false;
      }
      this.cdr.detectChanges();
    }
  }

  async loadBankData(
    register_uuid: string = null,
    versionToUse: number = null,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    if (!register_uuid) {
      register_uuid =
        this.approvalService.approvalData?.approval?.register?.id ||
        this.route.snapshot.params['id'];
    }

    if (versionType === 'main') {
      this.mainCardLoading.bank_information = true;
    } else if (versionType === 'comparing') {
      this.comparingCardLoading.bank_information = true;
    } else {
      this.cardLoading.bank_information = true;
    }

    try {
      const params: any = {
        data_type: 'bank_information',
      };

      if (versionToUse) {
        params.version = versionToUse;
      } else if (this.approvalService.approvalData.version) {
        params.version = this.approvalService.approvalData.version;
      } else {
        params.last = true;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: params,
        token: true,
      });

      if (response && response.data) {
        this.processBankInformationData(response, versionType);

        const v3Data = response.data;
        const versionData =
          v3Data.versions?.bank_information?.versions?.[0] ||
          v3Data.versions?.bank_information;

        if (versionData?.files) {
          this.processFiles(versionData.files, 'bank_account');
        }

        this.bankLoaded = true;

        // Atualizar cache se não estiver comparando versões
        if (!versionType && !this.comparingVersions) {
          const currentData =
            this.approvalService.approvalData.complementary_data || {};
          this.approvalService.approvalData.complementary_data = {
            ...currentData,
            register: {
              ...(currentData.register || {}),
              bank_information: this.bankData,
            },
          };
        }
      }
    } catch (error) {
      console.error('Error loading bank data:', error);
    } finally {
      if (versionType === 'main') {
        this.mainCardLoading.bank_information = false;
      } else if (versionType === 'comparing') {
        this.comparingCardLoading.bank_information = false;
      } else {
        this.cardLoading.bank_information = false;
      }
      this.cdr.detectChanges();
    }
  }

  async loadRiskData(
    register_uuid: string = null,
    versionToUse: number = null,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    if (!register_uuid) {
      register_uuid =
        this.approvalService.approvalData?.approval?.register?.id ||
        this.route.snapshot.params['id'];
    }

    if (versionType === 'main') {
      this.mainCardLoading.risk_information = true;
    } else if (versionType === 'comparing') {
      this.comparingCardLoading.risk_information = true;
    } else {
      this.cardLoading.risk_information = true;
    }

    try {
      const params: any = {
        data_type: 'risk_information',
      };

      if (versionToUse) {
        params.version = versionToUse;
      } else if (this.approvalService.approvalData.version) {
        params.version = this.approvalService.approvalData.version;
      } else {
        params.last = true;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: params,
        token: true,
      });

      if (response && response.data) {
        const v3Data = response.data;
        // Adjust for potential naming differences in V3 response structure
        const versionData =
          v3Data.versions?.risk_information?.versions?.[0] ||
          v3Data.versions?.risk_information;

        const riskData = versionData?.data || v3Data.data;

        // Atribuir dados
        const loadedRiskData = Array.isArray(riskData)
          ? riskData
          : riskData
            ? [riskData]
            : [];

        if (versionType === 'main') {
          this.mainRiskData = loadedRiskData;
        } else if (versionType === 'comparing') {
          this.comparingRiskData = loadedRiskData;
        } else {
          this.riskData = loadedRiskData;
          this.riskLoaded = true;
        }

        if (versionData?.files) {
          this.processFiles(versionData.files, 'risk_information');
        }
      }
    } catch (error) {
      console.error('Error loading risk data:', error);
    } finally {
      if (versionType === 'main') {
        this.mainCardLoading.risk_information = false;
      } else if (versionType === 'comparing') {
        this.comparingCardLoading.risk_information = false;
      } else {
        this.cardLoading.risk_information = false;
      }
      this.cdr.detectChanges();
    }
  }

  async loadEconomicGroupData(
    register_uuid: string = null,
    versionToUse: number = null,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    if (!register_uuid) {
      register_uuid =
        this.approvalService.approvalData?.approval?.register?.id ||
        this.route.snapshot.params['id'];
    }

    if (versionType === 'main') {
      this.mainCardLoading.economic_group = true;
    } else if (versionType === 'comparing') {
      this.comparingCardLoading.economic_group = true;
    } else {
      this.cardLoading.economic_group = true;
    }

    try {
      const params: any = {
        data_type: 'economic_groups',
      };

      if (versionToUse) {
        params.version = versionToUse;
      } else if (this.approvalService.approvalData.version) {
        params.version = this.approvalService.approvalData.version;
      } else {
        params.last = true;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: params,
        token: true,
      });

      if (response && response.data) {
        this.processEconomicGroupsData(response, versionType);

        const v3Data = response.data;
        const versionData =
          v3Data.versions?.economic_groups?.versions?.[0] ||
          v3Data.versions?.economic_group?.versions?.[0] ||
          v3Data.versions?.economic_groups ||
          v3Data.versions?.economic_group;

        if (versionData?.files) {
          this.processFiles(versionData.files, 'economic_group');
        }

        this.economicGroupLoaded = true;

        // Atualizar cache se não estiver comparando versões
        if (!versionType && !this.comparingVersions) {
          const currentData =
            this.approvalService.approvalData.complementary_data || {};
          this.approvalService.approvalData.complementary_data = {
            ...currentData,
            register: {
              ...(currentData.register || {}),
              economic_group: this.economicGroupData,
            },
          };
        }
      }
    } catch (error) {
      console.error('Error loading economic group data:', error);
    } finally {
      if (versionType === 'main') {
        this.mainCardLoading.economic_group = false;
      } else if (versionType === 'comparing') {
        this.comparingCardLoading.economic_group = false;
      } else {
        this.cardLoading.economic_group = false;
      }
      this.cdr.detectChanges();
    }
  }

  async loadComplementaryData(
    register_uuid: string,
    versionToUse: number,
    versionType: 'main' | 'comparing' | null,
  ) {
    if (versionType === 'main') {
      this.mainCardLoading.basic_data = true;
      this.mainCardLoading.pep_relationship = true;
    } else if (versionType === 'comparing') {
      this.comparingCardLoading.basic_data = true;
      this.comparingCardLoading.pep_relationship = true;
    } else {
      this.cardLoading.basic_data = true;
      this.cardLoading.pep_relationship = true;
    }

    try {
      const params: any = {
        data_type: 'complementary',
      };

      if (versionToUse) {
        params.version = versionToUse;
      } else if (this.approvalService.approvalData.version) {
        params.version = this.approvalService.approvalData.version;
      } else {
        params.last = true;
      }

      const response = await this.api.get<any>({
        route: `api/v3/registration/versions/register/${register_uuid}/`,
        params: params,
        token: true,
      });

      if (response && response.data) {
        this.processComplementaryData(response, versionType);
        this.syncApprovalQueueFromV3(response);

        // Atualizar cache se não estiver comparando versões
        if (!versionType && !this.comparingVersions) {
          const currentData =
            this.approvalService.approvalData.complementary_data || {};
          // Mapear dados para cache
          // Preservar address, bank e economic que podem já estar no cache
          this.approvalService.approvalData.complementary_data = {
            ...currentData,
            ...response.data, // Assumindo que response.data tem a estrutura correta para o cache raiz
            register: {
              ...(currentData.register || {}),
              // Mesclar dados do registro que vieram no complementary
              ...(this.approval.register || {}),
            },
          };
        }
      }
    } catch (error) {
      console.error('Error loading complementary data', error);
    } finally {
      if (versionType === 'main') {
        this.mainCardLoading.basic_data = false;
        this.mainCardLoading.pep_relationship = false;
      } else if (versionType === 'comparing') {
        this.comparingCardLoading.basic_data = false;
        this.comparingCardLoading.pep_relationship = false;
      } else {
        this.cardLoading.basic_data = false;
        this.cardLoading.pep_relationship = false;
      }
      this.cdr.detectChanges();
    }
  }

  // Helper helper to process files if needed (assuming logic from getApprovalData)
  processFiles(files: any, type: string) {
    // Simplified file processing logic to match what is likely done in getApprovalData
    // Ideally this should use the same logic as getApprovalData
    if (!this.filteredFiles) this.filteredFiles = {};

    const fileSlugs = [];
    Object.keys(files || {}).forEach((key) => {
      const file = files[key];
      if (file && file.slug) {
        fileSlugs.push(file.slug);
      }
    });

    if (fileSlugs.length > 0) {
      this.filteredFiles[type] = fileSlugs;
    }
  }

  ngOnDestroy() {
    if (this.stylesTimeout) {
      clearTimeout(this.stylesTimeout);
    }
    this.event?.unsubscribe();
    this.event2?.unsubscribe();
    this.eventMainVersion?.unsubscribe();
    this.eventComparingVersion?.unsubscribe();
  }

  ngOnInit(): void {
    if (this.comparingVersions) {
      this.loadComparingVersions();
    } else {
      // Sempre carregar dados da API v3, mesmo se já existir no cache
      // para garantir dados atualizados
      this.getApprovalData();
    }

    if (this.hasRepresentativeRole && !this.requestedSignsLoaded) {
      this.getRequestedSigns();
    }

    this.event2 = this.approvalService.changeVersion.subscribe(() => {
      if (!this.comparingVersions) {
        // Incrementar contador de loading v3 quando iniciar requisição
        this.approvalService.incrementV3Loading();

        // Ativar loading em todas as abas quando trocar de versão
        this.cardLoading = {
          basic_data: true,
          address: true,
          bank_information: true,
          pep_relationship: true,
          economic_group: true,
          risk_information: true,
        };
        this.getApprovalData();
      }
    });

    this.eventMainVersion = this.approvalService.changeMainVersion.subscribe(
      () => {
        if (this.comparingVersions) {
          this.loadMainVersion();
        }
      },
    );

    this.eventComparingVersion =
      this.approvalService.changeComparingVersion.subscribe(() => {
        if (this.comparingVersions) {
          this.loadComparingVersion();
        }
      });

    this.event = this.authService.reloadComplementaryDataEvent.subscribe(
      (params) => {
        if (!this.comparingVersions) {
          this.cardLoading = {
            basic_data: true,
            address: true,
            bank_information: true,
            pep_relationship: true,
            economic_group: true,
            risk_information: true,
          };
          this.getApprovalData(params);
        }
      },
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeTab'] && !changes['activeTab'].firstChange) {
      this.checkAndLoadTabData();
    }

    if (
      changes['hasRepresentativeRole'] &&
      this.hasRepresentativeRole &&
      !this.requestedSignsLoaded
    ) {
      this.getRequestedSigns();
    }

    // Detectar quando comparingVersions muda de true para false
    if (
      changes['comparingVersions'] &&
      !changes['comparingVersions'].firstChange
    ) {
      const previousValue = changes['comparingVersions'].previousValue;
      const currentValue = changes['comparingVersions'].currentValue;

      // Se parou de comparar versões, restaurar dados originais do cache
      if (previousValue === true && currentValue === false) {
        this.restoreOriginalData();
      }
    }
  }

  private restoreOriginalData() {
    // Verificar se há dados em cache
    if (this.approvalService.approvalData.complementary_data) {
      const cachedData = this.approvalService.approvalData.complementary_data;

      // Definir role antes de usar
      let range = this.router.url.split('/').length;
      this.role = this.router.url.split('/')[range - 2];

      // Restaurar dados principais
      this.approval = cachedData;

      // Restaurar dados específicos dos cards
      if (cachedData.register) {
        this.bankData = cachedData.register.bank_information || [];
        this.economicGroupData = cachedData.register.economic_group || [];
        this.pepData = cachedData.register.person?.pep_relationship || null;

        this.cards = cachedData.register.cards;
        this.isSimplified = cachedData.register.is_simplified || false;
        this.isFund = this.checkIsFund(cachedData.register);

        this.setFilteredFiles();

        // Restaurar dados de usuário
        const user = this.authService.getUser();
        const register = user?.active_register
          ? user.active_register.register
          : user;

        this.isAdmin = user
          ? register?.role?.slug?.includes('ADM') || false
          : false;

        if (cachedData.register.role?.slug?.includes('SHAREHOLDER')) {
          this.fatca = cachedData.register.profiles_quiz?.[0] || null;
        }

        if (this.role === 'shareholder') {
          this.declarations = cachedData.register.declaration_authorization
            ? cachedData.register.declaration_authorization[0]
            : null;
        }
      }

      // Desativar loading
      this.cardLoading = {
        basic_data: false,
        address: false,
        bank_information: false,
        pep_relationship: false,
        economic_group: false,
        risk_information: false,
      };

      this.cdr.detectChanges();
    } else {
      // Se não houver cache, carregar dados normalmente
      this.cardLoading = {
        basic_data: true,
        address: true,
        bank_information: true,
        pep_relationship: true,
        economic_group: true,
        risk_information: true,
      };
      this.getApprovalData();
    }
  }

  async getRequestedSigns() {
    this.requestedSignsLoaded = true;
    try {
      const representative_uuid =
        this.route.snapshot.params.id ||
        this.authService.user?.active_register?.register?.id;
      const response = await this.api.get<any>({
        route: 'api/v3/registration/registers/by-representative/',
        params: { representative_uuid },
        token: true,
      });

      const data = response?.data || response?.results || response || [];
      this.representativeData = (Array.isArray(data) ? data : []).map(
        (item: any) => {
          const personName = item?.person?.name;
          const companyName =
            item?.company?.corporate_name ||
            item?.company?.name ||
            item?.company?.fantasy_name;
          const document =
            item?.person?.document?.number ||
            item?.company?.document?.number ||
            item?.document?.number ||
            '';

          return {
            id: item?.id,
            name: personName || companyName || '--',
            document: document,
            needsSignature: !!item?.needs_signature,
          };
        },
      );
      this.cdr.detectChanges();
    } catch (error) {
      this.requestedSignsLoaded = false;
    }
  }

  openRepresentativeDetails(registerId: string) {
    if (!registerId) return;
    this.router.navigateByUrl(`/app/details/${registerId}`);
  }

  loadComparingVersions() {
    if (this.approvalService.approvalData.mainRevision) {
      this.loadMainVersion();
    }
    if (this.approvalService.approvalData.comparingRevision) {
      this.loadComparingVersion();
    }
  }

  loadMainVersion() {
    this.getApprovalData(null, 'main');
  }

  loadComparingVersion() {
    this.getApprovalData(null, 'comparing');
  }

  async getApprovalData(
    param: any = null,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    // Definir role antes de processar dados
    if (!this.role) {
      let range = this.router.url.split('/').length;
      this.role = this.router.url.split('/')[range - 2];
    }
    // Evitar chamadas simultâneas que podem causar loops
    if (versionType === 'main') {
      if (this.isLoadingMainData) {
        return;
      }
      this.isLoadingMainData = true;
    } else if (versionType === 'comparing') {
      if (this.isLoadingComparingData) {
        return;
      }
      this.isLoadingComparingData = true;
    } else {
      if (this.isLoadingData) {
        return;
      }
      this.isLoadingData = true;
    }

    try {
      if (versionType === 'main') {
        this.mainCardLoading = {
          basic_data: true,
          address: true,
          bank_information: true,
          pep_relationship: true,
          economic_group: true,
          risk_information: true,
        };
      } else if (versionType === 'comparing') {
        this.comparingCardLoading = {
          basic_data: true,
          address: true,
          bank_information: true,
          pep_relationship: true,
          economic_group: true,
          risk_information: true,
        };
      } else {
        this.cardLoading = {
          basic_data: true,
          address: true,
          bank_information: true,
          pep_relationship: true,
          economic_group: true,
          risk_information: true,
        };
      }

      const register_uuid = param ? param.id : this.route.snapshot.params['id'];

      if (!register_uuid) {
        console.warn('Register UUID não encontrado');
        return;
      }

      // Verificar se há versão específica selecionada
      let versionToUse = null;
      if (
        versionType === 'main' &&
        this.approvalService.approvalData.mainVersion
      ) {
        versionToUse = this.approvalService.approvalData.mainVersion;
      } else if (
        versionType === 'comparing' &&
        this.approvalService.approvalData.comparingVersion
      ) {
        versionToUse = this.approvalService.approvalData.comparingVersion;
      } else if (!versionType && this.approvalService.approvalData.version) {
        versionToUse = this.approvalService.approvalData.version;
      }

      // Execute all calls sequentially to prevent timeout/server overload
      await this.loadComplementaryData(
        register_uuid,
        versionToUse,
        versionType,
      );
      await this.loadAddressData(register_uuid, versionToUse, versionType);
      await this.loadBankData(register_uuid, versionToUse, versionType);
      await this.loadEconomicGroupData(
        register_uuid,
        versionToUse,
        versionType,
      );
      await this.loadRiskData(register_uuid, versionToUse, versionType);
    } catch (error) {
      console.error('Erro geral ao carregar dados complementares:', error);
    } finally {
      // Resetar flag apropriada
      if (versionType === 'main') {
        this.isLoadingMainData = false;
      } else if (versionType === 'comparing') {
        this.isLoadingComparingData = false;
      } else {
        this.isLoadingData = false;
        // Decrementar contador de loading v3 quando terminar requisição normal (não comparação)
        if (!this.comparingVersions) {
          this.approvalService.decrementV3Loading();
        }
      }
    }
  }

  /**
   * Processa os dados de complementary da API v3
   * Estrutura da resposta: data.versions.complementary.versions[0].data
   */
  private processComplementaryData(
    response: any,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    // Definir role se ainda não foi definido
    if (!this.role) {
      let range = this.router.url.split('/').length;
      this.role = this.router.url.split('/')[range - 2];
    }

    // Extrair dados da estrutura da API v3
    const versionData =
      response?.data?.versions?.complementary?.versions?.[0]?.data;
    const registerType = response?.data?.register_type;
    // O role pode estar em data.data.register.role
    const roleData = response?.data?.data?.register?.role || {};

    if (!versionData) {
      console.warn('Dados de versão não encontrados na resposta da API v3');
      return;
    }

    // Mapear para a estrutura esperada pelo componente
    let register: any = {};

    if (registerType === 'PF') {
      // Pessoa Física
      register = {
        type: 'PF',
        person: versionData,
        bank_information: versionData.bank_information || [],
        role: roleData || versionData.role || {},
        is_simplified:
          response?.data?.data?.register?.is_simplified ||
          versionData.is_simplified ||
          false,
        cards: versionData.cards || {},
      };
    } else if (registerType === 'PJ') {
      // Pessoa Jurídica
      register = {
        type: 'PJ',
        company: versionData,
        bank_information: versionData.bank_information || [],
        role: roleData || versionData.role || {},
        is_simplified:
          response?.data?.data?.register?.is_simplified ??
          versionData.is_simplified ??
          false,
        cards: versionData.cards || {},
      };
    } else {
      // Fallback: tentar usar response.register se existir (compatibilidade)
      register = response.register || {};
    }

    if (versionType === 'main') {
      if (!this.mainApproval) {
        this.mainApproval = { register: {} } as any;
      }
      this.mainApproval.register = {
        ...this.mainApproval.register,
        ...register,
      };
      // bank_information será processado pelo processAllData, não sobrescrever aqui
      // this.mainBankData = register.bank_information || [];
      // economic_group será processado pelo processEconomicGroupsData, não sobrescrever aqui
      this.mainPepData =
        register.person?.pep_relationship ||
        register.company?.pep_relationship ||
        null;
      this.mainIsFund = this.checkIsFund(register);
      this.mainIsSimplified = register.is_simplified || false;
      this.mainCards = register.cards;
      this.setFilteredFiles('main');
    } else if (versionType === 'comparing') {
      if (!this.comparingApproval) {
        this.comparingApproval = { register: {} } as any;
      }
      this.comparingApproval.register = {
        ...this.comparingApproval.register,
        ...register,
      };
      // bank_information será processado pelo processAllData, não sobrescrever aqui
      // this.comparingBankData = register.bank_information || [];
      // economic_group será processado pelo processEconomicGroupsData, não sobrescrever aqui
      this.comparingPepData =
        register.person?.pep_relationship ||
        register.company?.pep_relationship ||
        null;
      this.comparingIsFund = this.checkIsFund(register);
      this.comparingIsSimplified = register.is_simplified || false;
      this.comparingCards = register.cards;
      this.setFilteredFiles('comparing');
    } else {
      if (!this.approval) {
        this.approval = { register: {} } as any;
      }

      // Garantir que o register tenha type e company definidos
      this.approval.register = {
        ...this.approval.register,
        ...register,
        type: register.type || this.approval.register.type,
        company: register.company || this.approval.register.company,
      };

      // bank_information será processado pelo processAllData, não sobrescrever aqui
      // this.bankData = register.bank_information || [];
      // economic_group será processado pelo processEconomicGroupsData, não sobrescrever aqui
      this.pepData =
        register.person?.pep_relationship ||
        register.company?.pep_relationship ||
        null;
      this.isFund = this.checkIsFund(register);
      this.isSimplified = register.is_simplified || false;
      this.cards = register.cards;

      // Processar dados adicionais
      if (register.person?.secondary_document) {
        this.normalizeDocumentType(register.person.secondary_document);
      }

      const user = this.authService.getUser();
      const userRegister = user?.active_register
        ? user.active_register.register
        : user;

      this.isAdmin = user
        ? userRegister?.role?.slug?.includes('ADM') || false
        : false;

      if (register.role?.slug?.includes('SHAREHOLDER')) {
        this.fatca = register.profiles_quiz?.[0] || null;
      }

      if (this.role === 'shareholder') {
        this.declarations = register.declaration_authorization
          ? register.declaration_authorization[0]
          : null;
      }

      this.setFilteredFiles();
    }
  }

  /**
   * Sincroniza queue e current_department da API v3 com o approval
   * A API v3 retorna essas informações em data.queue e data.current_department
   */
  private syncApprovalQueueFromV3(response: any) {
    if (!response?.data) {
      return;
    }

    const queue = response.data.queue;
    const current_department = response.data.current_department;

    // Atualizar queue se existir na resposta
    if (queue && this.approval) {
      // Garantir que o approval tenha a estrutura queue
      if (!this.approval.queue) {
        this.approval.queue = {} as any;
      }

      // Atualizar departments se existir
      if (queue.departments && Array.isArray(queue.departments)) {
        this.approval.queue.departments = queue.departments;
      }

      // Atualizar outros campos do queue se existirem
      if (queue.id !== undefined) {
        this.approval.queue.id = queue.id;
      }
    }

    // Atualizar current_department se existir na resposta
    if (current_department && this.approval) {
      this.approval.current_department = {
        ...this.approval.current_department,
        ...current_department,
        // Garantir que department seja mapeado corretamente se vier apenas o name
        department:
          current_department.department ||
          (current_department.name
            ? { name: current_department.name }
            : this.approval.current_department?.department),
      };
    }

    // Atualizar approval no serviço se existir
    if (this.approvalService.approvalData.approval) {
      if (queue) {
        if (!this.approvalService.approvalData.approval.queue) {
          this.approvalService.approvalData.approval.queue = {} as any;
        }
        if (queue.departments && Array.isArray(queue.departments)) {
          this.approvalService.approvalData.approval.queue.departments =
            queue.departments;
        }
        if (queue.id !== undefined) {
          this.approvalService.approvalData.approval.queue.id = queue.id;
        }
      }

      if (current_department) {
        this.approvalService.approvalData.approval.current_department = {
          ...this.approvalService.approvalData.approval.current_department,
          ...current_department,
          department:
            current_department.department ||
            (current_department.name
              ? { name: current_department.name }
              : this.approvalService.approvalData.approval.current_department
                  ?.department),
        };
      }
    }

    // Emitir evento para notificar componentes que escutam
    this.approvalService.updateApprovalQueue.emit({
      queue,
      current_department,
    });
  }

  /**
   * Processa os dados de address da API v3
   * Estrutura da resposta: data.versions.address.versions[0].data (o objeto de endereço está diretamente aqui)
   */
  private processAddressData(
    response: any,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    // Extrair dados da estrutura da API v3
    // O objeto de endereço está diretamente em data.versions.address.versions[0].data
    const address = response?.data?.versions?.address?.versions?.[0]?.data;

    if (!address) {
      return;
    }

    this.addressLoaded = true;

    if (versionType === 'main') {
      if (this.mainApproval?.register) {
        this.mainApproval.register.address = address;
      }
    } else if (versionType === 'comparing') {
      if (this.comparingApproval?.register) {
        this.comparingApproval.register.address = address;
      }
    } else {
      if (this.approval?.register) {
        this.approval.register.address = address;
      }
    }
  }

  /**
   * Processa os dados de bank_information da API v3
   * Estrutura da resposta: data.versions.bank_information.versions[0].data (array de contas bancárias)
   */
  private processBankInformationData(
    response: any,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    // Extrair dados da estrutura da API v3
    // O array de contas bancárias está em data.versions.bank_information.versions[0].data
    const bankInformation =
      response?.data?.versions?.bank_information?.versions?.[0]?.data || [];

    if (!bankInformation || bankInformation.length === 0) {
      return;
    }

    this.bankLoaded = true;

    if (versionType === 'main') {
      if (this.mainApproval?.register) {
        this.mainApproval.register.bank_information = bankInformation;
      }
      this.mainBankData = bankInformation;
    } else if (versionType === 'comparing') {
      if (this.comparingApproval?.register) {
        this.comparingApproval.register.bank_information = bankInformation;
      }
      this.comparingBankData = bankInformation;
    } else {
      if (this.approval?.register) {
        this.approval.register.bank_information = bankInformation;
      }
      this.bankData = bankInformation;
    }
  }

  /**
   * Processa os dados de economic_groups da API v3
   * Estrutura da resposta: data.versions.economic_groups.versions[0].data (array de grupos econômicos)
   */
  private processEconomicGroupsData(
    response: any,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    // Extrair dados da estrutura da API v3
    // O array de grupos econômicos está em data.versions.economic_groups.versions[0].data
    const economicGroups =
      response?.data?.versions?.economic_groups?.versions?.[0]?.data || [];

    this.economicGroupLoaded = true;

    if (!economicGroups || economicGroups.length === 0) {
      // Se não houver grupos econômicos, definir como array vazio
      if (versionType === 'main') {
        this.mainEconomicGroupData = [];
      } else if (versionType === 'comparing') {
        this.comparingEconomicGroupData = [];
      } else {
        this.economicGroupData = [];
      }
      return;
    }

    // Mapear os dados para o formato esperado pelo componente
    const mappedEconomicGroups = economicGroups.map((item: any) => ({
      id: item.id,
      corporate_name: item.corporate_name || item.name || '',
      company_document_number:
        item.company_document_number ||
        item.document ||
        item.document_number ||
        '',
    }));

    if (versionType === 'main') {
      if (this.mainApproval?.register) {
        this.mainApproval.register.economic_group = mappedEconomicGroups;
      }
      this.mainEconomicGroupData = mappedEconomicGroups;
    } else if (versionType === 'comparing') {
      if (this.comparingApproval?.register) {
        this.comparingApproval.register.economic_group = mappedEconomicGroups;
      }
      this.comparingEconomicGroupData = mappedEconomicGroups;
    } else {
      if (this.approval?.register) {
        this.approval.register.economic_group = mappedEconomicGroups;
      }
      this.economicGroupData = mappedEconomicGroups;
    }
  }

  /**
   * @deprecated Este método usa a API v2 e não deve ser mais usado.
   * Use getApprovalData() que utiliza as APIs v3.
   * Mantido apenas para compatibilidade com código legado.
   */
  async getPartialData(
    params: any,
    card: string,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    console.warn(
      'getPartialData está deprecated. Use getApprovalData() com API v3.',
    );
    try {
      const res = await this.api.get<UserApprovalResponse[]>({
        route: `api/v2/approvals/version/`,
        token: true,
        params: { ...params, card: card === 'basic_data' ? '' : card },
      });

      if (versionType === 'main') {
        this.mainCardLoading[card] = false;
        this.setPartialData(card, res[0], 'main');
      } else if (versionType === 'comparing') {
        this.comparingCardLoading[card] = false;
        this.setPartialData(card, res[0], 'comparing');
      } else {
        this.cardLoading[card] = false;
        this.setPartialData(card, res[0]);

        // Atualizar cache apenas se não estiver em modo de comparação
        // para evitar loops de atualização
        if (!this.comparingVersions) {
          const resgister = this.approvalService.approvalData.complementary_data
            ? this.approvalService.approvalData.complementary_data.register
            : {};

          this.approvalService.approvalData.complementary_data = {
            ...this.approvalService.approvalData.complementary_data,
            ...res[0],
            register: {
              ...resgister,
              ...res[0].register,
            },
          };
        }
      }
    } catch (error) {
      console.error('Erro ao carregar dados', error);
      if (versionType === 'main') {
        this.mainCardLoading[card] = false;
      } else if (versionType === 'comparing') {
        this.comparingCardLoading[card] = false;
      } else {
        this.cardLoading[card] = false;
      }
    }
  }

  private setPartialData(
    card: string,
    res: any,
    versionType: 'main' | 'comparing' | null = null,
  ) {
    let range = this.router.url.split('/').length;
    this.role = this.router.url.split('/')[range - 2];

    if (versionType === 'main') {
      const approval = this.mainApproval || res[0];
      const register = this.mainApproval?.register || res[0]?.register || {};

      this.mainApproval = {
        ...res[0],
        ...approval,
        register: {
          ...res[0]?.register,
          ...register,
          ...res.register,
        },
      };

      if (this.mainApproval.register?.person?.secondary_document) {
        this.normalizeDocumentType(
          this.mainApproval.register.person.secondary_document,
        );
      }

      if (card === 'bank_information') {
        this.mainBankData = res.register.bank_information || [];
      }

      if (card === 'economic_group') {
        this.mainIsFund = this.checkIsFund(res.register);
        this.mainEconomicGroupData = res.register.economic_group || [];
      }

      if (card === 'pep_relationship') {
        this.mainPepData = res.register.person?.pep_relationship || null;
      }

      if (card === 'address') {
        if (this.mainApproval.register) {
          this.mainApproval.register.address = res.register.address;
        }
      }

      if (!this.mainCardLoading.basic_data && this.mainApproval.register) {
        this.mainCards = this.mainApproval.register.cards;
        this.mainIsSimplified =
          this.mainApproval.register.is_simplified || false;
        this.setFilteredFiles('main');
        this.cdr.detectChanges();
        // Aplicar estilos apenas após todos os cards carregarem
        this.scheduleApplyStyles();
      }
    } else if (versionType === 'comparing') {
      const approval = this.comparingApproval || res[0];
      const register =
        this.comparingApproval?.register || res[0]?.register || {};

      this.comparingApproval = {
        ...res[0],
        ...approval,
        register: {
          ...res[0]?.register,
          ...register,
          ...res.register,
        },
      };

      if (this.comparingApproval.register?.person?.secondary_document) {
        this.normalizeDocumentType(
          this.comparingApproval.register.person.secondary_document,
        );
      }

      if (card === 'bank_information') {
        this.comparingBankData = res.register.bank_information || [];
      }

      if (card === 'economic_group') {
        this.comparingIsFund = this.checkIsFund(res.register);
        this.comparingEconomicGroupData = res.register.economic_group || [];
      }

      if (card === 'pep_relationship') {
        this.comparingPepData = res.register.person?.pep_relationship || null;
      }

      if (card === 'address') {
        if (this.comparingApproval.register) {
          this.comparingApproval.register.address = res.register.address;
        }
      }

      if (
        !this.comparingCardLoading.basic_data &&
        this.comparingApproval.register
      ) {
        this.comparingCards = this.comparingApproval.register.cards;
        this.comparingIsSimplified =
          this.comparingApproval.register.is_simplified || false;
        this.setFilteredFiles('comparing');
        this.cdr.detectChanges();
        // Aplicar estilos apenas após todos os cards carregarem
        this.scheduleApplyStyles();
      }
    } else {
      const approval = this.approval || res[0];
      const register = this.approval?.register || res[0]?.register || {};

      this.approval = {
        ...res[0],
        ...approval,
        register: {
          ...res[0]?.register,
          ...register,
        },
      };

      if (this.approval.register?.person?.secondary_document) {
        this.normalizeDocumentType(
          this.approval.register.person.secondary_document,
        );
      }

      if (card === 'bank_information') {
        this.bankData = res.register.bank_information || [];
      }

      if (card === 'economic_group') {
        this.isFund = this.checkIsFund(res.register);
        this.economicGroupData = res.register.economic_group || [];
      }

      if (card === 'pep_relationship') {
        this.pepData = res.register.person?.pep_relationship || null;
      }

      if (card === 'address') {
        if (this.approval.register) {
          this.approval.register.address = res.register.address;
        }
      }

      if (!this.cardLoading.basic_data && this.approval.register) {
        this.cards = this.approval.register.cards;
        this.isSimplified = this.approval.register.is_simplified || false;
        this.setFilteredFiles();

        const user = this.authService.getUser();
        const register = user?.active_register
          ? user.active_register.register
          : user;

        this.isAdmin = user
          ? register?.role?.slug?.includes('ADM') || false
          : false;
        this.isFund = this.checkIsFund(this.approval.register);

        if (this.approval.register.role?.slug?.includes('SHAREHOLDER')) {
          this.fatca = this.approval.register.profiles_quiz?.[0] || null;
        }

        if (this.role === 'shareholder') {
          this.declarations = this.approval.register.declaration_authorization
            ? this.approval.register.declaration_authorization[0]
            : null;
        }
      }
    }
  }

  //   setData() {
  //     this.bankData = this.approval.register.bank_information;

  //     this.economicGroupData = this.approval.register.economic_group;
  //     this.pepData =
  //       this.approval.register.person &&
  //       this.approval.register.person.pep_relationship
  //         ? [this.approval.register.person.pep_relationship]
  //         : null;
  //     this.cards = this.approval.register.cards;
  //     this.isSimplified = this.approval.register.is_simplified;

  //     this.setFilteredFiles();
  //     let range = this.router.url.split('/').length;
  //     this.role = this.router.url.split('/')[range - 2];
  //     const user = this.authService.getUser();

  //     this.handleGetDocuments();

  //     const register = user.active_register
  //       ? user.active_register.register
  //       : user;

  //     this.isAdmin = user ? register.role.slug.includes('ADM') : false;
  //     this.isFund = this.approval.register.role.slug.includes('PJ-FI');

  //     if (this.approval.register.role.slug.includes('SHAREHOLDER')) {
  //       this.fatca = this.approval.register.profiles_quiz[0];
  //     }

  //     if (this.role === 'shareholder') {
  //       this.declarations = this.approval.register.declaration_authorization
  //         ? this.approval.register.declaration_authorization[0]
  //         : null;
  //     }

  //     this.loading = false;
  //   }

  setFilteredFiles(versionType: 'main' | 'comparing' | null = null) {
    if (versionType === 'main') {
      this.mainFilteredFiles = {};
      if (!this.mainCards) return;

      Object.keys(this.mainCards).forEach((cardSlug) => {
        const card = this.mainCards[cardSlug];
        const eachItem: fileSlugArrProps[] = [];

        const newCard =
          card.files?.filter((file) => file.referent === 'register') || [];

        newCard.forEach((file) => {
          if (!eachItem.find((item) => item.slug === file.type.slug)) {
            eachItem.push({ slug: file.type.slug, label: file.type.name });
          }
        });

        this.mainFilteredFiles = {
          ...this.mainFilteredFiles,
          [cardSlug]: eachItem,
        };
      });
    } else if (versionType === 'comparing') {
      this.comparingFilteredFiles = {};
      if (!this.comparingCards) return;

      Object.keys(this.comparingCards).forEach((cardSlug) => {
        const card = this.comparingCards[cardSlug];
        const eachItem: fileSlugArrProps[] = [];

        const newCard =
          card.files?.filter((file) => file.referent === 'register') || [];

        newCard.forEach((file) => {
          if (!eachItem.find((item) => item.slug === file.type.slug)) {
            eachItem.push({ slug: file.type.slug, label: file.type.name });
          }
        });

        this.comparingFilteredFiles = {
          ...this.comparingFilteredFiles,
          [cardSlug]: eachItem,
        };
      });
    } else {
      this.filteredFiles = {};
      if (!this.cards) return;

      Object.keys(this.cards).forEach((cardSlug) => {
        const card = this.cards[cardSlug];
        const eachItem: fileSlugArrProps[] = [];

        const newCard =
          card.files?.filter((file) => file.referent === 'register') || [];

        newCard.forEach((file) => {
          if (!eachItem.find((item) => item.slug === file.type.slug)) {
            eachItem.push({ slug: file.type.slug, label: file.type.name });
          }
        });

        this.filteredFiles = {
          ...this.filteredFiles,
          [cardSlug]: eachItem,
        };
      });
    }
  }

  getPointsName(points: any) {
    if (points) {
      if (points >= 9 && points <= 18) {
        return 'Conservador';
      } else if (points >= 19 && points <= 28) {
        return 'Moderado';
      } else if (points > 28) {
        return 'Agressivo';
      } else {
        return 'Insuficiente';
      }
    }
    return 'Não possui';
  }

  getPointsColor(points: any) {
    if (points) {
      if (points >= 9 && points <= 18) {
        return '#2ecc71';
      } else if (points >= 19 && points <= 28) {
        return '#f1c40f';
      } else if (points > 28) {
        return '#e74c3c';
      } else {
        return '#c0392b';
      }
    }
    return '#f1c40f';
  }

  formatPhone(phone) {
    if (!phone) return '--';

    if (phone.length === 11) {
      return this.maskPipe.transform(phone, '(00) 00000-0000');
    } else {
      return this.maskPipe.transform(phone, '(00) 0000-0000');
    }
  }

  getEmployeesName(value: string) {
    const label = this.employeesOptions.find((item) => item.value === value);

    return label ? label.label : '--';
  }

  getChoicesName(object: string, value: any) {
    const choices = this.signupService.signupChoices;

    const choiceObject = choices[object];

    if (choiceObject) {
      return choiceObject.find((_choice) => _choice.value == value);
    }

    return { label: '', value: '' };
  }

  formatBrl(amount: number | string) {
    const formatted = Utils.formatBrl(Number(amount));

    return formatted;
  }

  formatCnpj(value: string) {
    const newValue = this.maskPipe.transform(value, '00.000.000/0000-00');

    return newValue;
  }

  formatCpf(obj: any) {
    // Verificar se obj existe antes de acessar suas propriedades
    if (!obj) {
      return '--';
    }

    // Se obj é uma string, tentar formatar diretamente
    if (typeof obj === 'string') {
      if (obj.length === 11) {
        return this.maskPipe.transform(obj, '000.000.000-00');
      }
      return obj;
    }

    // Se obj tem a propriedade number
    if (obj.number) {
      if (obj.number.length === 11) {
        return this.maskPipe.transform(obj.number, '000.000.000-00');
      }
      return obj.number;
    }

    // Se obj não tem number mas é um objeto, tentar formatar o próprio obj como string
    if (typeof obj === 'object') {
      const objString = String(obj);
      if (objString.length === 11 && /^\d+$/.test(objString)) {
        return this.maskPipe.transform(objString, '000.000.000-00');
      }
    }

    return '--';
  }

  formatRg(item: any) {
    const newValue = this.maskPipe.transform(item.number, '00.000.000-0');
    const agency = item.dispatching_agency.split(' ')[0];

    return newValue;
  }

  formatDocument(item: any) {
    let newValue = item.number;
    let agency = item.dispatching_agency.split(' ')[0];
    let docType = this.getChoicesName('document_type', item.type)?.label;

    if (item.type === '34') {
      newValue = this.maskPipe.transform(item.number, '00.000.000-0');
      docType = 'RG';
    }

    if (item.type === '1') {
      docType = 'CNH';
    }

    return newValue;
  }

  handleFormatDocument(item: any) {
    if (item.type?.name === 'Carteira de Identidade') {
      return this.formatRg(item);
    }

    if (item.type?.name === 'Cadastro Pessoa Fisica') {
      return this.formatCpf(item);
    }

    return item.number;
  }

  handleSelect(slug: any, cardSlug: string) {
    const files = this.cards[cardSlug].files.filter(
      (item) => item.type.slug === slug,
    );

    this.openFile(files);

    //   this.getImgUrl();
  }

  getImgUrl(attachment: Partial<AttachmentListValues>) {
    let url: any = attachment.file;
    let type: string = '';

    const regex = /\.([0-9a-z]+)(?:[\?#]|$)/i;

    const resultado = regex.exec(attachment.file);

    if (resultado && resultado[1]) {
      type = resultado[1].toLowerCase();
    }

    if (type === 'pdf') {
      url = this.sanitizer.bypassSecurityTrustResourceUrl(attachment.file);
    }

    if (type === 'xls' || type === 'xlsx') {
      url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://view.officeapps.live.com/op/embed.aspx?src=${attachment.file}`,
      );
    }

    let auxExtensionTypes = ['pdf', 'xls', 'xlsx'];

    return {
      url,
      isImg: !auxExtensionTypes.includes(type),
      name: this.formatFileName(attachment.file),
    };
  }

  formatFileName(file: string) {
    return file.split('/').pop()?.split('.').shift();
  }

  openFile(attachments: Partial<AttachmentListValues>[]) {
    this.modalFiles = attachments;

    const newModalFilesUrls = attachments.map(
      (attachment: Partial<AttachmentListValues>) => this.getImgUrl(attachment),
    );

    this.modalFilesUrls = newModalFilesUrls;
    this.selectedFile = newModalFilesUrls[0];

    this.modalRoot.show();
  }

  setPrevAttachment() {
    const index = this.modalFilesUrls?.findIndex(
      (item) => item.url === this.selectedFile?.url,
    );

    if (index === 0) return;

    this.selectedFile = this.modalFilesUrls[index - 1];
  }

  setNextAttachment() {
    const index = this.modalFilesUrls?.findIndex(
      (item) => item.url === this.selectedFile?.url,
    );

    if (index === this.modalFilesUrls?.length - 1) return;

    this.selectedFile = this.modalFilesUrls[index + 1];
  }

  getDisabled(direction) {
    const index = this.modalFilesUrls?.findIndex(
      (item) => item.url === this.selectedFile?.url,
    );

    if (direction === 'prev') {
      return index === 0;
    } else {
      return index === this.modalFilesUrls?.length - 1;
    }
  }

  urlDecoding(label: string) {
    return decodeURIComponent(label);
  }

  renderContractType(contractType: string) {
    let label: string = 'Digital';

    if (contractType === 'physical') {
      label = 'Físico';
    }

    return label;
  }

  formateDate(date: string) {
    const day = date.split('T').shift()?.split('-').reverse().join('/');
    const hours = date.split('T').pop()?.slice(0, 5);

    return `${day} às ${hours}`;
  }

  openUsPerson(file: string) {
    window.open(file, '_blank');
  }

  getRiskLabel(risk: number) {
    let label = '';

    switch (risk) {
      case 1:
        label = 'Conservador';
        break;
      case 2:
        label = 'Moderado';
        break;
      case 3:
        label = 'Agressivo';
        break;
      default:
        label = '--';
        break;
    }

    return label;
  }

  dataCheckForReverseRow() {
    const verify1 = this.role === 'shareholder';

    const verify2 =
      this.approval.register.type !== 'PJ' && this.pepData !== null;

    const verify3 = this.role === 'shareholder' && !this.isFund;

    return verify1 && !(verify2 || verify3);
  }

  renderValue(parentPath: string[], key) {
    return Utils.renderValue(parentPath, key, this.approval);
  }

  getNacionality(value: any) {
    const choices = this.signupService.nationalityChocies;

    if (value) {
      return choices.find((_choice) => _choice.value == value);
    }

    return { label: '', value: '' };
  }

  /**
   * Retorna o nome da nacionalidade formatado
   * Se for 23, retorna "Brasil"
   */
  getNationalityDisplay(value: any): string {
    if (!value) {
      return '--';
    }

    // Se for 23, retorna "Brasil"
    if (value === 23 || value === '23') {
      return 'Brasil';
    }

    // Caso contrário, tenta buscar nas choices
    const nationality = this.getNacionality(value);
    return nationality?.label || value || '--';
  }

  // Função para normalizar o tipo de documento
  normalizeDocumentType(document: any) {
    if (!document || !document.type) return;

    // Se o type já é um objeto com name, não precisa fazer nada
    if (typeof document.type === 'object' && document.type.name) {
      return;
    }

    // Se o type é apenas um ID (string ou number), buscar o nome correspondente
    if (
      typeof document.type === 'string' ||
      typeof document.type === 'number'
    ) {
      const documentTypes = this.signupService.choices().document_types;
      const typeId = parseInt(document.type.toString());
      const foundType = documentTypes.find((type) => type.value == typeId);

      if (foundType) {
        document.type = {
          id: foundType.value,
          name: foundType.label,
        };
      }
    }
  }

  // Função para renderizar o estado (naturalidade)
  // Helper methods para obter dados baseado no contexto
  getApprovalDataForView(
    versionType: 'main' | 'comparing' | null = null,
  ): UserApprovalResponse {
    if (!this.comparingVersions) return this.approval;
    if (versionType === 'main') return this.mainApproval;
    if (versionType === 'comparing') return this.comparingApproval;
    return this.approval;
  }

  getCardLoadingForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.cardLoading;
    if (versionType === 'main') return this.mainCardLoading;
    if (versionType === 'comparing') return this.comparingCardLoading;
    return this.cardLoading;
  }

  getFilteredFilesForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.filteredFiles;
    if (versionType === 'main') return this.mainFilteredFiles;
    if (versionType === 'comparing') return this.comparingFilteredFiles;
    return this.filteredFiles;
  }

  getBankDataForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.bankData;
    if (versionType === 'main') return this.mainBankData;
    if (versionType === 'comparing') return this.comparingBankData;
    return this.bankData;
  }

  getEconomicGroupDataForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.economicGroupData;
    if (versionType === 'main') return this.mainEconomicGroupData;
    if (versionType === 'comparing') return this.comparingEconomicGroupData;
    return this.economicGroupData;
  }

  getPepDataForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.pepData;
    if (versionType === 'main') return this.mainPepData;
    if (versionType === 'comparing') return this.comparingPepData;
    return this.pepData;
  }

  getIsFundForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.isFund;
    if (versionType === 'main') return this.mainIsFund;
    if (versionType === 'comparing') return this.comparingIsFund;
    return this.isFund;
  }

  getIsSimplifiedForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.isSimplified;
    if (versionType === 'main') return this.mainIsSimplified;
    if (versionType === 'comparing') return this.comparingIsSimplified;
    return this.isSimplified;
  }

  getCardsForView(versionType: 'main' | 'comparing' | null = null) {
    if (!this.comparingVersions) return this.cards;
    if (versionType === 'main') return this.mainCards;
    if (versionType === 'comparing') return this.comparingCards;
    return this.cards;
  }

  getStateDisplayName(stateName: string | number): string {
    if (!stateName) return '--';

    // Se é string com menos de 3 caracteres, é um ID numérico como string
    if (typeof stateName === 'string' && stateName.length < 3) {
      const numericId = parseInt(stateName, 10);
      if (!isNaN(numericId)) {
        const stateOption = this.signupService.ufs_ids.find(
          (uf) => uf.value === numericId,
        );
        return stateOption ? stateOption.label : '--';
      }
    }

    // Se é número, buscar diretamente no ufs_ids
    if (typeof stateName === 'number') {
      const stateOption = this.signupService.ufs_ids.find(
        (uf) => uf.value === stateName,
      );
      return stateOption ? stateOption.label : '--';
    }

    // Se é string com mais de 3 caracteres, é nome completo
    if (typeof stateName === 'string' && stateName.length > 3) {
      // Mapeamento de nomes completos para siglas
      const stateNameToSigla: { [key: string]: string } = {
        'São Paulo': 'SP',
        'Rio de Janeiro': 'RJ',
        'Minas Gerais': 'MG',
        Bahia: 'BA',
        Paraná: 'PR',
        'Rio Grande do Sul': 'RS',
        Pernambuco: 'PE',
        Ceará: 'CE',
        Pará: 'PA',
        'Santa Catarina': 'SC',
        Goiás: 'GO',
        Maranhão: 'MA',
        Paraíba: 'PB',
        'Espírito Santo': 'ES',
        Piauí: 'PI',
        Alagoas: 'AL',
        Tocantins: 'TO',
        'Rio Grande do Norte': 'RN',
        Acre: 'AC',
        Amapá: 'AP',
        Amazonas: 'AM',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        Rondônia: 'RO',
        Roraima: 'RR',
        Sergipe: 'SE',
        'Distrito Federal': 'DF',
      };

      return stateNameToSigla[stateName] || stateName;
    }

    // Se é string com 2 caracteres, provavelmente já é sigla
    if (typeof stateName === 'string' && stateName.length === 2) {
      return stateName.toUpperCase();
    }

    return '--';
  }

  /**
   * Verifica se o registro é um fundo (PJ-FI)
   * Verifica primeiro no array roles, depois no role único
   * @param register Objeto register a verificar (opcional, usa this.approval.register se não fornecido)
   * @returns true se algum role tem slug que inclui 'PJ-FI'
   */
  checkIsFund(register?: any): boolean {
    const localRegister = register || this.approval?.register;
    const globalRegister =
      this.approvalService.approvalData?.approval?.register || null;

    const registerToCheck = localRegister || globalRegister;
    if (!registerToCheck && !globalRegister) {
      return false;
    }

    // Escolher de onde pegar os roles: primeiro do register atual, senão do approval global
    const rolesSource =
      (registerToCheck && registerToCheck.roles) ||
      (globalRegister && globalRegister.roles) ||
      null;

    // Verificar primeiro no array de roles (múltiplos papéis)
    if (rolesSource && Array.isArray(rolesSource) && rolesSource.length > 0) {
      const hasFundRole = rolesSource.some((role: any) => {
        if (!role || !role.slug) return false;
        return role.slug.includes('PJ-FI');
      });
      if (hasFundRole) {
        return true;
      }
    }

    // Fallback: verificar no role único (compatibilidade com código antigo)
    const roleSlug =
      registerToCheck?.role?.slug || globalRegister?.role?.slug || null;

    if (roleSlug) {
      const isFundBySingleRole = roleSlug && roleSlug.includes('PJ-FI');
      return isFundBySingleRole;
    }

    return false;
  }

  /**
   * Verifica se o registro tem o papel shareholder que NÃO é fundo
   * Isso diferencia "shareholder" (cotista PJ) de "shareholder-PJ-FI" (cotista PJ fundo)
   * @param versionType Tipo de versão a verificar ('main', 'comparing' ou null para versão atual)
   * @returns true se o registro tem o papel shareholder que não é fundo (slug não contém PJ-FI)
   */
  hasShareholderRole(versionType: 'main' | 'comparing' | null = null): boolean {
    const approval = this.getApprovalDataForView(versionType);
    if (!approval || !approval.register) {
      return false;
    }

    const register = approval.register;

    // Verificar primeiro no array de roles (múltiplos papéis)
    if (
      register.roles &&
      Array.isArray(register.roles) &&
      register.roles.length > 0
    ) {
      // Verificar se tem algum papel shareholder que NÃO seja fundo
      return register.roles.some(
        (role: any) =>
          role?.applicable === 'shareholder' &&
          role?.slug &&
          !role.slug.includes('PJ-FI'),
      );
    }

    // Fallback: verificar no role único (compatibilidade com código antigo)
    return (
      register.role?.applicable === 'shareholder' &&
      register.role?.slug &&
      !register.role.slug.includes('PJ-FI')
    );
  }

  /**
   * Verifica se o usuário possui algum dos papéis especificados
   * @param roleNames Array de strings com os nomes dos papéis a verificar (ex: ['assignor', 'shareholder', 'provider'])
   * @param versionType Tipo de versão a verificar ('main', 'comparing' ou null para versão atual)
   * @returns true se o usuário possui pelo menos um dos papéis especificados
   */
  hasAnyRole(
    roleNames: string[],
    versionType: 'main' | 'comparing' | null = null,
  ): boolean {
    if (!roleNames || roleNames.length === 0) {
      return false;
    }

    // Obter o approval baseado no versionType
    const approval = this.getApprovalDataForView(versionType);
    if (!approval || !approval.register) {
      return false;
    }

    const register = approval.register;

    // Normalizar os nomes dos papéis para comparação (lowercase)
    const normalizedRoleNames = roleNames.map((name) =>
      name.toLowerCase().trim(),
    );

    // Verificar primeiro no array de roles (múltiplos papéis)
    if (
      register.roles &&
      Array.isArray(register.roles) &&
      register.roles.length > 0
    ) {
      const hasRole = register.roles.some((role: any) => {
        if (!role) return false;

        // Verificar pelo campo 'applicable' ou 'slug'
        const roleApplicable = role?.applicable?.toLowerCase();
        const roleSlug = role?.slug?.toLowerCase();

        // Verificar se algum dos nomes especificados corresponde ao role
        return normalizedRoleNames.some((searchName) => {
          return (
            roleApplicable === searchName ||
            roleSlug?.includes(searchName) ||
            roleSlug?.includes(searchName.toUpperCase())
          );
        });
      });

      if (hasRole) {
        return true;
      }
    }

    // Fallback: verificar no role único (compatibilidade com código antigo)
    if (register.role) {
      const roleApplicable = register.role?.applicable?.toLowerCase();
      const roleSlug = register.role?.slug?.toLowerCase();

      const hasRole = normalizedRoleNames.some((searchName) => {
        return (
          roleApplicable === searchName ||
          roleSlug?.includes(searchName) ||
          roleSlug?.includes(searchName.toUpperCase())
        );
      });

      if (hasRole) {
        return true;
      }
    }

    // Fallback final: verificar na propriedade role do componente (da URL)
    if (this.role) {
      return normalizedRoleNames.includes(this.role.toLowerCase());
    }

    return false;
  }

  // Função para comparar valores e retornar classe de cor (apenas para lado direito/comparing)
  getComparisonColor(
    mainValue: any,
    comparingValue: any,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    // Apenas aplicar cores no lado direito (comparing)
    if (versionType !== 'comparing' || !this.comparingVersions) {
      return '';
    }

    const normalizeValue = (val: any): string => {
      if (val === null || val === undefined || val === '') return '';
      if (typeof val === 'boolean') return val ? 'sim' : 'não';
      if (typeof val === 'string') {
        const trimmed = val.toLowerCase().trim();
        // Normalizar valores comuns
        if (trimmed === 'sim' || trimmed === 'yes' || trimmed === 'true')
          return 'sim';
        if (
          trimmed === 'não' ||
          trimmed === 'nao' ||
          trimmed === 'no' ||
          trimmed === 'false'
        )
          return 'não';
        return trimmed;
      }
      return String(val).toLowerCase().trim();
    };

    const mainNorm = normalizeValue(mainValue);
    const comparingNorm = normalizeValue(comparingValue);

    // Verde: informação foi adicionada (esquerdo não tem, direito tem)
    if (!mainNorm && comparingNorm) {
      return 'text-success'; // Verde
    }

    // Vermelho: informação foi removida (esquerdo tem, direito não tem)
    if (mainNorm && !comparingNorm) {
      return 'text-danger'; // Vermelho
    }

    // Amarelo: valores são diferentes (ex: esquerdo "sim", direito "não")
    if (mainNorm && comparingNorm && mainNorm !== comparingNorm) {
      return 'text-warning'; // Amarelo
    }

    return '';
  }

  // Função helper para obter valor do main quando estiver no contexto comparing
  getMainValueForComparison(path: string): any {
    if (!this.comparingVersions || !this.mainApproval) return null;

    // Tratamento especial para campos PEP
    if (path.startsWith('pep.')) {
      const field = path.replace('pep.', '') as 'name' | 'document' | 'bound';
      if (this.mainPepData) {
        const value = this.mainPepData[field];
        // Tratar string vazia como null
        if (value && typeof value === 'string' && value.trim() !== '') {
          return value;
        }
      }
      return null;
    }

    const keys = path.split('.');
    let value: any = this.mainApproval;

    for (const key of keys) {
      if (value && typeof value === 'object') {
        if (key in value) {
          value = value[key];
        } else {
          // Se a chave não existe, retornar null
          return null;
        }
      } else {
        // Se value não é um objeto, não podemos continuar navegando
        return null;
      }
    }

    return value;
  }

  // Função helper para obter cor de comparação usando caminho de propriedade
  getComparisonColorByPath(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    if (versionType !== 'comparing' || !this.comparingVersions) {
      return '';
    }

    const mainValue = this.getMainValueForComparison(path);
    const comparingValue = this.getComparingValueForComparison(path);

    return this.getComparisonColor(mainValue, comparingValue, versionType);
  }

  // Método para determinar status do campo (added, removed, modified, unchanged)
  getFieldStatus(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): 'added' | 'removed' | 'modified' | 'unchanged' {
    if (!this.comparingVersions || !versionType) return 'unchanged';

    // Tratamento especial para campos PEP
    if (path.startsWith('pep.')) {
      const field = path.replace('pep.', '') as 'name' | 'document' | 'bound';
      return this.getPepFieldStatus(field, versionType);
    }

    const mainValue = this.getMainValueForComparison(path);
    const comparingValue = this.getComparingValueForComparison(path);

    // Tratamento especial para objetos (como address)
    if (path === 'register.address') {
      const mainAddr = mainValue as any;
      const comparingAddr = comparingValue as any;

      if (!mainAddr && comparingAddr) {
        return versionType === 'comparing' ? 'added' : 'unchanged';
      }
      if (mainAddr && !comparingAddr) {
        return versionType === 'comparing' ? 'removed' : 'unchanged';
      }
      if (mainAddr && comparingAddr) {
        const mainStr = `${mainAddr?.cep || ''}_${
          mainAddr?.public_place || ''
        }_${mainAddr?.number || ''}_${mainAddr?.complement || ''}_${
          mainAddr?.district || ''
        }_${mainAddr?.city || ''}_${mainAddr?.uf || ''}`
          .toLowerCase()
          .trim();
        const comparingStr = `${comparingAddr?.cep || ''}_${
          comparingAddr?.public_place || ''
        }_${comparingAddr?.number || ''}_${comparingAddr?.complement || ''}_${
          comparingAddr?.district || ''
        }_${comparingAddr?.city || ''}_${comparingAddr?.uf || ''}`
          .toLowerCase()
          .trim();
        if (mainStr !== comparingStr) {
          return 'modified';
        }
      }
      return 'unchanged';
    }

    const normalizeValue = (val: any): string => {
      if (val === null || val === undefined || val === '') return '';
      if (typeof val === 'boolean') return val ? 'sim' : 'não';
      if (typeof val === 'object') {
        // Para objetos, comparar propriedades principais
        if (path.includes('address')) {
          const addr = val as any;
          return `${addr?.cep || ''}_${addr?.public_place || ''}_${
            addr?.number || ''
          }_${addr?.complement || ''}_${addr?.district || ''}_${
            addr?.city || ''
          }_${addr?.uf || ''}`
            .toLowerCase()
            .trim();
        }
        return JSON.stringify(val).toLowerCase().trim();
      }
      if (typeof val === 'string') {
        const trimmed = val.toLowerCase().trim();
        if (trimmed === 'sim' || trimmed === 'yes' || trimmed === 'true')
          return 'sim';
        if (
          trimmed === 'não' ||
          trimmed === 'nao' ||
          trimmed === 'no' ||
          trimmed === 'false'
        )
          return 'não';
        return trimmed;
      }
      return String(val).toLowerCase().trim();
    };

    const mainNorm = normalizeValue(mainValue);
    const comparingNorm = normalizeValue(comparingValue);

    // Se não existe no main mas existe no comparing = added
    if (!mainNorm && comparingNorm) {
      return versionType === 'comparing' ? 'added' : 'unchanged';
    }

    // Se existe no main mas não existe no comparing = removed
    if (mainNorm && !comparingNorm) {
      return versionType === 'comparing' ? 'removed' : 'unchanged';
    }

    // Se ambos existem, verificar se são diferentes
    if (mainNorm && comparingNorm && mainNorm !== comparingNorm) {
      return 'modified';
    }

    return 'unchanged';
  }

  // Método para retornar ícone de comparação para um campo
  getFieldComparisonIcon(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    if (versionType !== 'comparing') return '';
    const status = this.getFieldStatus(path, versionType);
    switch (status) {
      case 'added':
        return '<img src="/assets/images/carbon-checkmark.svg" class="comparison-icon" style="width: 16px; height: 16px; margin-right: 6px;" alt="check" />';
      case 'removed':
        return '<img src="/assets/images/carbon-error-warning.svg" class="comparison-icon" style="width: 16px; height: 16px; margin-right: 6px;" alt="error" />';
      case 'modified':
        return '<img src="/assets/images/carbon-warning.svg" class="comparison-icon" style="width: 16px; height: 16px; margin-right: 6px;" alt="warning" />';
      default:
        return '';
    }
  }

  // Método auxiliar para verificar se há ícone de comparação
  hasFieldComparisonIcon(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): boolean {
    return this.getFieldComparisonIcon(path, versionType) !== '';
  }

  // Método para retornar o valor a ser exibido (mostra valor do main se foi removido)
  getFieldValueForDisplay(
    path: string,
    currentValue: any,
    versionType: 'main' | 'comparing' | null = null,
  ): any {
    if (!this.comparingVersions || versionType !== 'comparing') {
      return currentValue;
    }

    const status = this.getFieldStatus(path, versionType);
    if (status === 'removed') {
      // Se foi removido, mostrar o valor original do main
      const mainValue = this.getMainValueForComparison(path);
      // Retornar o valor do main quando foi removido
      if (mainValue !== null && mainValue !== undefined && mainValue !== '') {
        return mainValue;
      }
      // Se não encontrou, tentar acessar diretamente do mainApproval
      if (this.mainApproval) {
        const keys = path.split('.');
        let value: any = this.mainApproval;
        for (const key of keys) {
          if (value && typeof value === 'object' && key in value) {
            value = value[key];
          } else {
            break;
          }
        }
        if (value !== null && value !== undefined && value !== '') {
          return value;
        }
      }
      return '';
    }

    return currentValue;
  }

  // Método para retornar classe CSS de strikethrough para campos removidos
  getFieldStrikethroughClass(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    if (!this.comparingVersions || versionType !== 'comparing') {
      return '';
    }

    const status = this.getFieldStatus(path, versionType);
    if (status === 'removed') {
      return 'text-decoration-line-through';
    }

    return '';
  }

  // Método helper para obter todas as classes CSS do campo de uma vez
  getFieldAllClasses(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    const strikethrough = this.getFieldStrikethroughClass(path, versionType);
    const border = this.getFieldBorderClass(path, versionType);
    return [strikethrough, border].filter((c) => c).join(' ');
  }

  // Método para obter classe CSS do campo baseado no status
  getFieldBorderClass(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    if (!this.comparingVersions || versionType !== 'comparing') {
      return '';
    }

    const status = this.getFieldStatus(path, versionType);
    switch (status) {
      case 'modified':
        return 'field-compare-modified';
      case 'added':
        return 'field-compare-added';
      case 'removed':
        return 'field-compare-removed';
      default:
        return '';
    }
  }

  // Método para obter estilo de border-bottom baseado no status
  getFieldBorderStyle(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    if (!this.comparingVersions || versionType !== 'comparing') {
      return 'none';
    }

    const status = this.getFieldStatus(path, versionType);
    switch (status) {
      case 'modified':
        return '2px solid #ffc107';
      case 'added':
        return '2px solid #28a745';
      case 'removed':
        return '2px solid #dc3545';
      default:
        return 'none';
    }
  }

  // Método helper para verificar se o campo precisa de padding-bottom
  getFieldPaddingBottom(
    path: string,
    versionType: 'main' | 'comparing' | null = null,
  ): string {
    if (!this.comparingVersions || versionType !== 'comparing') {
      return '0';
    }
    const status = this.getFieldStatus(path, versionType);
    return status !== 'unchanged' ? '8px' : '0';
  }

  // Função helper para obter valor do comparing quando estiver no contexto comparing
  getComparingValueForComparison(path: string): any {
    if (!this.comparingVersions || !this.comparingApproval) return null;

    // Tratamento especial para campos PEP
    if (path.startsWith('pep.')) {
      const field = path.replace('pep.', '') as 'name' | 'document' | 'bound';
      if (this.comparingPepData) {
        const value = this.comparingPepData[field];
        // Tratar string vazia como null
        if (value && typeof value === 'string' && value.trim() !== '') {
          return value;
        }
      }
      return null;
    }

    const keys = path.split('.');
    let value: any = this.comparingApproval;

    for (const key of keys) {
      if (value && value[key] !== undefined) {
        value = value[key];
      } else {
        return null;
      }
    }

    return value;
  }

  // Métodos de comparação para tabelas (Bank, Economic Group, PEP)

  // Método genérico para obter status de item em tabelas
  getTableItemStatus<T extends { id: number | string }>(
    item: T,
    mainData: T[],
    comparingData: T[],
    versionType: 'main' | 'comparing' | null,
  ): 'modified' | 'added' | 'removed' | 'unchanged' {
    if (!this.comparingVersions || !versionType) return 'unchanged';

    const itemId = item.id;
    const mainItem = mainData.find((i) => i.id === itemId);
    const comparingItem = comparingData.find((i) => i.id === itemId);

    if (!mainItem && comparingItem) {
      return versionType === 'comparing' ? 'added' : 'unchanged';
    }

    if (mainItem && !comparingItem) {
      return versionType === 'comparing' ? 'removed' : 'unchanged';
    }

    if (mainItem && comparingItem) {
      // Verificar se foi modificado comparando os objetos
      const isModified =
        JSON.stringify(mainItem) !== JSON.stringify(comparingItem);
      return isModified ? 'modified' : 'unchanged';
    }

    return 'unchanged';
  }

  // Status para Bank
  getBankItemStatus(
    item: Bankinformation,
    versionType: 'main' | 'comparing' | null,
  ): 'modified' | 'added' | 'removed' | 'unchanged' {
    return this.getTableItemStatus(
      item,
      this.mainBankData,
      this.comparingBankData,
      versionType,
    );
  }

  // Status para Economic Group
  getEconomicGroupItemStatus(
    item: Economicgroup,
    versionType: 'main' | 'comparing' | null,
  ): 'modified' | 'added' | 'removed' | 'unchanged' {
    return this.getTableItemStatus(
      item,
      this.mainEconomicGroupData,
      this.comparingEconomicGroupData,
      versionType,
    );
  }

  // Status geral do PEP (verifica se o objeto inteiro mudou)
  getPepStatus(
    versionType: 'main' | 'comparing' | null,
  ): 'modified' | 'added' | 'removed' | 'unchanged' {
    if (!this.comparingVersions || !versionType) return 'unchanged';

    // Função helper para verificar se objeto PEP tem dados válidos
    const hasValidData = (
      data: CompanyComplementaryPepListValues | null,
    ): boolean => {
      if (!data) return false;
      const hasName =
        data.name && typeof data.name === 'string' && data.name.trim() !== '';
      const hasDocument =
        data.document &&
        typeof data.document === 'string' &&
        data.document.trim() !== '';
      const hasBound =
        data.bound &&
        typeof data.bound === 'string' &&
        data.bound.trim() !== '';
      return hasName || hasDocument || hasBound;
    };

    const mainHasData = hasValidData(this.mainPepData);
    const comparingHasData = hasValidData(this.comparingPepData);

    // Se não tem dados válidos em nenhum, não mudou
    if (!mainHasData && !comparingHasData) return 'unchanged';

    // Se tem dados no main mas não no comparing, foi removido
    if (mainHasData && !comparingHasData) {
      return versionType === 'comparing' ? 'removed' : 'unchanged';
    }

    // Se tem dados no comparing mas não no main, foi adicionado
    if (!mainHasData && comparingHasData) {
      return versionType === 'comparing' ? 'added' : 'unchanged';
    }

    // Se ambos têm dados válidos, verificar se foi modificado
    if (
      mainHasData &&
      comparingHasData &&
      this.mainPepData &&
      this.comparingPepData
    ) {
      const isModified =
        JSON.stringify(this.mainPepData) !==
        JSON.stringify(this.comparingPepData);
      return isModified ? 'modified' : 'unchanged';
    }

    return 'unchanged';
  }

  // Classe CSS para linha da tabela
  getTableItemRowClass(
    status: 'modified' | 'added' | 'removed' | 'unchanged',
    versionType: 'main' | 'comparing' | null,
  ): string {
    if (versionType !== 'comparing') return '';
    switch (status) {
      case 'modified':
        return 'row-compare-modified';
      case 'added':
        return 'row-compare-added';
      case 'removed':
        return 'row-compare-removed';
      default:
        return '';
    }
  }

  // Ícone para item da tabela
  getTableItemIcon(
    status: 'modified' | 'added' | 'removed' | 'unchanged',
    versionType: 'main' | 'comparing' | null,
  ): string {
    if (versionType !== 'comparing') return '';
    switch (status) {
      case 'added':
        return '<img src="/assets/images/carbon-checkmark.svg" class="comparison-icon" style="width: 16px; height: 16px;" alt="check" />';
      case 'removed':
        return '<img src="/assets/images/carbon-error-warning.svg" class="comparison-icon" style="width: 16px; height: 16px;" alt="error" />';
      case 'modified':
        return '<img src="/assets/images/carbon-warning.svg" class="comparison-icon" style="width: 16px; height: 16px;" alt="warning" />';
      default:
        return '';
    }
  }

  // Método para incluir itens removidos no lado direito (para tabelas)
  getTableDataForComparison<T extends { id?: number | string }>(
    mainData: T[],
    comparingData: T[],
    versionType: 'main' | 'comparing' | null,
  ): T[] {
    if (!this.comparingVersions) return comparingData;
    if (versionType === 'main') return mainData;
    if (versionType === 'comparing') {
      // Incluir itens removidos (que existem apenas no main) também no lado direito
      const removedItems = mainData.filter((mainItem) => {
        return !comparingData.find((comparingItem) => {
          // Para PEP, usar document ou name como identificador
          if ('document' in mainItem && 'document' in comparingItem) {
            return (
              (mainItem as any).document === (comparingItem as any).document ||
              (mainItem as any).name === (comparingItem as any).name
            );
          }
          // Para outros tipos, usar id
          return comparingItem.id === mainItem.id;
        });
      });
      return [...comparingData, ...removedItems];
    }
    return comparingData;
  }

  // Método específico para PEP (que não tem id)
  // Método para obter status do campo PEP (integra com getFieldStatus)
  getPepFieldStatus(
    field: 'name' | 'document' | 'bound',
    versionType: 'main' | 'comparing' | null,
  ): 'modified' | 'added' | 'removed' | 'unchanged' {
    if (!this.comparingVersions || !versionType) return 'unchanged';

    const mainData = this.mainPepData;
    const comparingData = this.comparingPepData;

    // Função helper para normalizar valor (string vazia = null)
    const normalizeValue = (val: any): string | null => {
      if (!val || val === null || val === undefined) return null;
      if (typeof val === 'string' && val.trim() === '') return null;
      return String(val).trim();
    };

    const mainValue = normalizeValue(mainData?.[field]);
    const comparingValue = normalizeValue(comparingData?.[field]);

    // Se não existe no main mas existe no comparing = added
    if (!mainValue && comparingValue) {
      return versionType === 'comparing' ? 'added' : 'unchanged';
    }

    // Se existe no main mas não existe no comparing = removed
    if (mainValue && !comparingValue) {
      return versionType === 'comparing' ? 'removed' : 'unchanged';
    }

    // Se ambos existem, verificar se são diferentes
    if (mainValue && comparingValue && mainValue !== comparingValue) {
      return 'modified';
    }

    return 'unchanged';
  }

  // Método para obter valor do campo PEP com comparação
  getPepFieldValueForDisplay(
    field: 'name' | 'document' | 'bound',
    versionType: 'main' | 'comparing' | null,
  ): string {
    // Se está comparando e o campo foi removido, mostrar valor do main
    if (this.comparingVersions && versionType === 'comparing') {
      const status = this.getPepFieldStatus(field, versionType);
      if (status === 'removed') {
        // Campo foi removido, mostrar valor do main com strikethrough
        const mainData = this.mainPepData;
        if (mainData) {
          const mainValue = mainData[field];
          // Tratar string vazia como ausência de dados
          if (
            mainValue &&
            typeof mainValue === 'string' &&
            mainValue.trim() !== ''
          ) {
            return mainValue;
          }
        }
      }
    }

    const data = this.getPepDataForView(versionType);
    if (!data) {
      return '--';
    }
    const value = data[field];
    // Tratar string vazia como ausência de dados
    if (!value || (typeof value === 'string' && value.trim() === '')) {
      return '--';
    }
    return value;
  }

  // Método helper para exibir valor PEP na visualização única (trata string vazia)
  getPepFieldDisplay(field: 'name' | 'document' | 'bound'): string {
    if (!this.pepData) {
      return '--';
    }
    const value = this.pepData[field];
    // Tratar string vazia, null ou undefined como ausência de dados
    if (!value || (typeof value === 'string' && value.trim() === '')) {
      return '--';
    }
    return value;
  }

  // Métodos para obter colunas com ícones de comparação
  getBankColumnsForView(
    versionType: 'main' | 'comparing' | null = null,
  ): TableColumnList<Bankinformation>[] {
    if (!this.comparingVersions || versionType !== 'comparing') {
      return this.bankColumns;
    }

    return [
      {
        name: 'Banco',
        cell: (row) => {
          const status = this.getBankItemStatus(row, versionType);
          const icon = this.getTableItemIcon(status, versionType);
          const rowClass = this.getTableItemRowClass(status, versionType);
          const wrapperClass = rowClass
            ? `row-compare-wrapper ${rowClass}`
            : '';
          return `
            <div class="${wrapperClass}" style="display: flex; flex-direction: row; align-items: center; gap: 3px; flex-wrap: nowrap;">
              <div style="flex-shrink: 0; display: inline-block; vertical-align: middle;">${icon}</div>
              <span style="${
                status === 'removed' ? 'text-decoration: line-through;' : ''
              }">${row.bank.bank_code} - ${row.bank.name}</span>
            </div>
          `;
        },
        size: 2,
      },
      {
        name: 'Conta',
        cell: (row) => {
          const status = this.getBankItemStatus(row, versionType);
          return `
            <span style="${
              status === 'removed' ? 'text-decoration: line-through;' : ''
            }">
              Ag: ${row.agency} Conta: ${row.account_number}${
                row.account_digit ? '-' + row.account_digit : ''
              }
            </span>
          `;
        },
      },
      {
        name: 'Tipo de conta',
        cell: (row) => {
          const status = this.getBankItemStatus(row, versionType);
          return `
            <span style="${
              status === 'removed' ? 'text-decoration: line-through;' : ''
            }">${row.account_type_display ?? 'Conta corrente'}</span>
            <span class="app-table-details-body-row-subtitle" style="${
              status === 'removed' ? 'text-decoration: line-through;' : ''
            }">
              ${row.main_account ? 'Conta principal' : ''}
            </span>
          `;
        },
      },
    ];
  }

  getEconomicGroupColumnsForView(
    versionType: 'main' | 'comparing' | null = null,
  ): TableColumnList<Economicgroup>[] {
    if (!this.comparingVersions || versionType !== 'comparing') {
      return this.economicGroupColumns;
    }

    return [
      {
        name: 'Razão Social',
        cell: (row) => {
          const status = this.getEconomicGroupItemStatus(row, versionType);
          const icon = this.getTableItemIcon(status, versionType);
          const rowClass = this.getTableItemRowClass(status, versionType);
          const wrapperClass = rowClass
            ? `row-compare-wrapper ${rowClass}`
            : '';
          return `
            <div class="${wrapperClass}" style="display: flex; flex-direction: row; align-items: center; gap: 3px; flex-wrap: nowrap;">
              <div style="flex-shrink: 0; display: inline-block; vertical-align: middle;">${icon}</div>
              <span style="${
                status === 'removed' ? 'text-decoration: line-through;' : ''
              }">${row.corporate_name.toUpperCase()}</span>
            </div>
          `;
        },
      },
      {
        name: 'CNPJ',
        cell: (row) => {
          const status = this.getEconomicGroupItemStatus(row, versionType);
          return `
            <span style="${
              status === 'removed' ? 'text-decoration: line-through;' : ''
            }">${this.formatCnpj(row.company_document_number)}</span>
          `;
        },
      },
    ];
  }

  // Helpers para formatação e tradução
  formatCurrencyBrl(value: any): string {
    if (value === null || value === undefined || value === '') return '-';

    // Converter para número se for string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numValue)) return '-';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(numValue);
  }

  getRiskInformationLabel(risk: string): string {
    if (!risk) return '-';

    const riskMap: { [key: string]: string } = {
      high: 'Alto',
      medium: 'Médio',
      low: 'Baixo',
      critical: 'Crítico',
      none: 'Nenhum',
    };

    return riskMap[risk.toLowerCase()] || risk;
  }

  ngAfterViewInit(): void {
    // Não aplicar estilos aqui - será aplicado após carregar dados
  }

  // Método para agendar aplicação de estilos com debounce
  private scheduleApplyStyles() {
    if (!this.comparingVersions) return;

    if (this.stylesTimeout) {
      clearTimeout(this.stylesTimeout);
    }

    // Só aplicar se todos os cards já carregaram
    const mainCardsLoaded =
      !this.mainCardLoading.basic_data &&
      !this.mainCardLoading.address &&
      !this.mainCardLoading.bank_information &&
      !this.mainCardLoading.pep_relationship &&
      !this.mainCardLoading.economic_group;

    const comparingCardsLoaded =
      !this.comparingCardLoading.basic_data &&
      !this.comparingCardLoading.address &&
      !this.comparingCardLoading.bank_information &&
      !this.comparingCardLoading.pep_relationship &&
      !this.comparingCardLoading.economic_group;

    if (mainCardsLoaded && comparingCardsLoaded) {
      this.stylesTimeout = setTimeout(() => {
        if (this.isApplyingStyles) {
          this.stylesTimeout = null;
          return;
        }
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.applyComparisonStyles();
            this.stylesTimeout = null;
          });
        });
      }, 500); // Delay maior para garantir que DOM está pronto
    }
  }

  applyComparisonStyles() {
    if (!this.comparingVersions || this.isApplyingStyles) {
      this.isApplyingStyles = false;
      return;
    }
    this.isApplyingStyles = true;

    try {
      // Aplicar estilos apenas no lado direito (comparing)
      // Encontrar todas as tabelas de comparação (segundo col-6)
      const comparingContainer =
        this.el.nativeElement.querySelector('.col-6:last-child');
      if (!comparingContainer) {
        this.isApplyingStyles = false;
        return;
      }

      // Processar tabela de Bank
      const bankCard = Array.from(
        comparingContainer.querySelectorAll('.dash-details-card'),
      ).find((card: any) => card.textContent?.includes('Contas bancárias')) as
        | HTMLElement
        | undefined;
      if (bankCard) {
        const bankRows = bankCard.querySelectorAll('.app-table-details-body');
        const bankData = this.getTableDataForComparison(
          this.mainBankData,
          this.comparingBankData,
          'comparing',
        );
        bankRows.forEach((row: any, index: number) => {
          row.classList.remove(
            'row-compare-modified',
            'row-compare-added',
            'row-compare-removed',
          );
          if (bankData[index]) {
            const status = this.getBankItemStatus(bankData[index], 'comparing');
            if (status !== 'unchanged') {
              row.classList.add(`row-compare-${status}`);
            }
          }
        });
      }

      // Processar tabela de Economic Group
      const economicGroupCard = Array.from(
        comparingContainer.querySelectorAll('.dash-details-card'),
      ).find((card: any) => card.textContent?.includes('Grupo econômico')) as
        | HTMLElement
        | undefined;
      if (economicGroupCard) {
        const economicGroupRows = economicGroupCard.querySelectorAll(
          '.app-table-details-body',
        );
        const economicData = this.getTableDataForComparison(
          this.mainEconomicGroupData,
          this.comparingEconomicGroupData,
          'comparing',
        );
        economicGroupRows.forEach((row: any, index: number) => {
          row.classList.remove(
            'row-compare-modified',
            'row-compare-added',
            'row-compare-removed',
          );
          if (economicData[index]) {
            const status = this.getEconomicGroupItemStatus(
              economicData[index],
              'comparing',
            );
            if (status !== 'unchanged') {
              row.classList.add(`row-compare-${status}`);
            }
          }
        });
      }

      // Processar tabela de PEP
      const pepRows = comparingContainer.querySelectorAll(
        '.dash-details-card .app-table-details-body',
      );
      // PEP agora é um objeto único
      const pepStatus = this.getPepStatus('comparing');
      pepRows.forEach((row: any) => {
        const container = row.closest('.dash-details-card');
        if (container && container.textContent?.includes('PEP')) {
          row.classList.remove(
            'row-compare-modified',
            'row-compare-added',
            'row-compare-removed',
          );
          if (pepStatus !== 'unchanged') {
            row.classList.add(`row-compare-${pepStatus}`);
          }
        }
      });
    } catch (error) {
      console.error('Erro ao aplicar estilos de comparação:', error);
    } finally {
      this.isApplyingStyles = false;
    }
  }

  /**
   * Verifica se há dados básicos para exibir no card
   */
  hasBasicData(): boolean {
    if (!this.approval || !this.approval.register) {
      return false;
    }

    const type = this.approval.register.type;
    const isFund = this.isFund;
    const isSimplified = this.isSimplified;

    // Verificar condições para PJ
    if (type === 'PJ') {
      if (isFund) return true;
      if (isSimplified) return true;
      if (
        (this.role === 'assignor' || this.role === 'shareholder') &&
        !isSimplified &&
        !isFund
      )
        return true;
      if (this.role === 'provider') return true;
    }

    // Verificar condições para PF
    if (type === 'PF') {
      if (this.role !== 'provider' && !isSimplified) return true;
      if (this.role === 'provider' && !isSimplified) return true;
      if (isSimplified) return true;
    }

    return false;
  }

  /**
   * Verifica se há endereço cadastrado
   */
  hasAddress(): boolean {
    if (
      !this.approval ||
      !this.approval.register ||
      !this.approval.register.address
    ) {
      return false;
    }
    const address = this.approval.register.address;
    return !!(
      address.cep ||
      address.public_place ||
      address.number ||
      address.district ||
      address.city ||
      address.uf
    );
  }

  /**
   * Verifica se há contas bancárias cadastradas
   */
  hasBankAccounts(): boolean {
    return this.bankData && this.bankData.length > 0;
  }

  /**
   * Verifica se há relacionamento PEP cadastrado com dados válidos
   */
  hasPepRelationship(): boolean {
    if (!this.pepData) {
      return false;
    }

    // Verificar se há dados válidos (não string vazia, null, undefined ou apenas hífens)
    const hasName =
      this.pepData.name &&
      typeof this.pepData.name === 'string' &&
      this.pepData.name.trim() !== '' &&
      this.pepData.name !== '-';
    const hasDocument =
      this.pepData.document &&
      typeof this.pepData.document === 'string' &&
      this.pepData.document.trim() !== '' &&
      this.pepData.document !== '-';
    const hasBound =
      this.pepData.bound &&
      typeof this.pepData.bound === 'string' &&
      this.pepData.bound.trim() !== '' &&
      this.pepData.bound !== '-';

    return hasName || hasDocument || hasBound;
  }

  /**
   * Verifica se há relacionamento PEP cadastrado com dados válidos para o modo comparação
   */
  hasPepRelationshipForView(
    versionType: 'main' | 'comparing' | null = null,
  ): boolean {
    const data = this.getPepDataForView(versionType);

    if (!data) {
      return false;
    }

    // Verificar se há dados válidos (não string vazia, null, undefined ou apenas hífens)
    const hasName =
      data.name &&
      typeof data.name === 'string' &&
      data.name.trim() !== '' &&
      data.name !== '-';
    const hasDocument =
      data.document &&
      typeof data.document === 'string' &&
      data.document.trim() !== '' &&
      data.document !== '-';
    const hasBound =
      data.bound &&
      typeof data.bound === 'string' &&
      data.bound.trim() !== '' &&
      data.bound !== '-';

    return hasName || hasDocument || hasBound;
  }

  /**
   * Renderiza o label da qualificação
   */
  renderQualificationLabel(qualification: string): string {
    const qualificationOptions = [
      { label: 'Certificado', value: 'certified' },
      { label: 'Qualificado', value: 'qualified' },
      { label: 'Profissional', value: 'professional' },
    ];

    const found = qualificationOptions.find(
      (item) => item.value === qualification,
    );

    return found?.label ?? '-';
  }

  /**
   * Renderiza o label da condição de investidor
   */
  renderInvestorConditionLabel(condition: string): string {
    const conditionMap: { [key: string]: string } = {
      never: 'Investidor Profissional',
      up_to_five: 'Investidor Qualificado',
      up_to_fifteen: 'Investidor Certificado',
    };

    return conditionMap[condition] ?? condition ?? '-';
  }

  /**
   * Verifica se é cotista (shareholder)
   */
  isShareholder(): boolean {
    if (!this.approval || !this.approval.register) {
      return false;
    }

    const register = this.approval.register;

    // Verificar primeiro no array de roles (múltiplos papéis)
    if (
      register.roles &&
      Array.isArray(register.roles) &&
      register.roles.length > 0
    ) {
      return register.roles.some(
        (role: any) => role?.applicable === 'shareholder',
      );
    }

    // Fallback: verificar no role único (compatibilidade com código antigo)
    return register.role?.applicable === 'shareholder';
  }

  /**
   * Obtém os dados de investor profile (qualification e investor_condition)
   */
  getInvestorProfileData(): {
    qualification: string;
    investor_condition: string;
  } | null {
    if (!this.registrationExpirationInfo?.raw) {
      return null;
    }

    const raw = this.registrationExpirationInfo.raw;
    return {
      qualification: raw.qualification || null,
      investor_condition: raw.investor_condition || null,
    };
  }
}
